<template lang="pug">
	.creative-ai-settings(v-if="showed && creative" v-window)
		.card(@click.stop)
			.card-header
				i.fa.fa-edit
				span Creative AI Settings
				.project-id Creative id: {{creative.id}}
			.card-body.collapse.show
				.form-horizontal
					//- Доступный текущему пользователю в креативе ИИ бюджет по источникам в порядке траты (видят все пользователи)
					.form-group.available-budget.separator
						label Available AI budget: {{availableBudgetDescription || '...'}}
						.description.text-muted
							span Money you can spend on the AI features in this creative
					.form-group.budget.separator(v-if="isSuperAdmin || isPublisherAdmin")
						template(v-if="budget")
							label Available creative AI budget: ${{budget['ai_budget'].toFixed(2)}}
							.budget-line Total spent on AI in the creative: ${{budget['ai_budget_spent'].toFixed(2)}}
						label(v-else) Available creative AI budget: ...
					.form-group.budget-transfer.separator(v-if="isPublisherAdmin && publisherBudget")
						label Company AI budget: ${{publisherBudget['ai_budget'].toFixed(2)}}
						template(v-if="publisherBudget['ai_budget_split']")
							.description.text-muted
								span Company admins can transfer the company AI budget to the creative and back
							.form-line.budget
								InputSelect(:key="`transfer-amount-${transferInputKey}`" v-on:change="setTransferAmount($event)" :default="0" :value="transferAmount" :values="counts" :options="transferInputOptions" type="number" theme="dark-medium")
								button.btn.btn-primary.btn-sm(type="button" :disabled="!(transferAmount > 0) || transferAmount > publisherBudget['ai_budget']" @click="transferToCreative()")
									i.fa.fa-arrow-right
									span Transfer to the creative
								button.btn.btn-outline-primary.btn-sm(type="button" :disabled="!(transferAmount > 0) || !budget || transferAmount > budget['ai_budget']" @click="transferToPublisher()")
									i.fa.fa-arrow-left
									span Transfer to the company
						.description.text-muted(v-else)
							span Enable creatives and users AI budgets in the Company AI settings to transfer the company AI budget to creatives
					.form-group.budget-change.separator(v-if="isSuperAdmin")
						label Change creative AI budget
						.description.text-muted
							span Super admins can add or remove AI budget from the creative with a reason
						.form-line.budget
							InputSelect(:key="`budget-amount-${budgetInputKey}`" v-on:change="setBudgetAmount($event)" :default="0" :value="amount" :values="counts" :options="{dropdownWidth: 80}" type="number" theme="dark-medium")
							input.form-control.form-control-sm.reason(type="text" v-model="reason" placeholder="Reason" maxlength="300")
						.form-line.budget-buttons
							button.btn.btn-primary.btn-sm(type="button" :disabled="!canChangeBudget()" @click="addBudget()")
								i.fa.fa-plus
								span Add AI budget
							button.btn.btn-danger.btn-sm(type="button" :disabled="!canChangeBudget()" @click="removeBudget()")
								i.fa.fa-minus
								span Remove AI budget
					.form-group.creative-ai-cost.separator
						label AI budget spend
						.description.text-muted
							span See who spent how much money on AI functionality for this creative
						.columns-3(v-if="aiUsers[0].length > 0")
							.column
								.multi-select-checkbox(v-for="user in aiUsers[0]")
									.form-check-label {{user.name}} (${{user.cost.toFixed(2)}})
							.column
								.multi-select-checkbox(v-for="user in aiUsers[1]")
									.form-check-label {{user.name}} (${{user.cost.toFixed(2)}})
							.column
								.multi-select-checkbox(v-for="user in aiUsers[2]")
									.form-check-label {{user.name}} (${{user.cost.toFixed(2)}})
						.empty-users(v-else) There are no ai money spent in this creative
					.form-group.budget-log.separator(v-if="budget")
						label AI budget changes
						.description.text-muted
							span When, who and why added, removed or transferred the creative AI budget
						.budget-log-records(v-if="log.length" key="budget-log-records" v-bar :style="{height: `${Math.min(log.length, MAX_VISIBLE_LOG_RECORDS) * LOG_RECORD_HEIGHT}px`}")
							.budget-log-records-inner
								.budget-log-record(v-for="record in log" :key="record.id" :style="{height: `${LOG_RECORD_HEIGHT}px`}")
									.date {{formatDate(record.date)}}
									.amount(:class="{negative: record.amount < 0}") {{record.amount < 0 ? '-' : '+'}}${{Math.abs(record.amount).toFixed(2)}}
									.user {{record.userName || 'System'}}
									.reason(:title="record.reason") {{record.reason}}
						.empty-log(v-else key="empty-log") There are no AI budget changes yet
					.form-actions
						button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import { Creative } 			from '../../services/Creative'
	import { Version } 			from '../../services/Version'
	import { Settings } 		from '../../services/Settings'

	import InputSelect			from './../Editor/Controls/InputSelect'

	export default {
		name: "CreativeSettingsAI",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Updated",
				"Creative AI Budget Changed",
				"Publisher AI Budget Changed",
				"Publishers Changed"
			],
			events: {
			}
		},
		components: {
			InputSelect
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.aiUsers = [[], [], []];

			// Сколько записей списка изменений бюджета видно без прокрутки и высота одной записи
			this.MAX_VISIBLE_LOG_RECORDS = 7;
			this.LOG_RECORD_HEIGHT = 32;

			this.log = [];

			this.counts = [
				{title: '$1', data: {itemValue: 1}},
				{title: '$5', data: {itemValue: 5}},
				{title: '$15', data: {itemValue: 15}},
				{title: '$50', data: {itemValue: 50}},
				{title: '$150', data: {itemValue: 150}}
			];

			// Сумма перевода, выбранная из меню, уменьшается до возможной (ручной ввод не изменяется)
			this.transferInputOptions = {
				dropdownWidth: 80,
				selectTransform: amount => this.limitTransferAmount(amount)
			};

			return {
				amount: 0,
				reason: '',
				transferAmount: 0,
				// Смена ключа пересоздаёт поле ввода суммы - так оно очищается (InputSelect хранит введённое значение у себя)
				transferInputKey: 0,
				budgetInputKey: 0
			}
		},
		methods: {
			collectData(eventName) {

				if (!Creative.SelectedCreative) return;

				this.creative = Creative.SelectedCreative;

				this.isSuperAdmin = !!User.currentUser.Tags['super-admin'];
				this.isPublisherAdmin = Publisher.isPublisherAdmin(this.creative['publisher_id']);
				this.budget = Creative.AIBudgets[this.creative.id];
				this.log = Creative.AIBudgetLogs[this.creative.id] || [];
				this.publisherBudget = Publisher.AIBudgets[this.creative['publisher_id']];
				// Админы и супер-админы тратят свой личный бюджет разработчика и бюджет своего паблишера - подписываем источники с названием дашборда
				this.availableBudgetDescription = Creative.getAvailableAIBudgetDescription(this.creative, !!(User.currentUser.Tags['admin'] || User.currentUser.Tags['super-admin']));

				// Доступный ИИ бюджет загружаем при открытии окна. Бюджет креатива, список его изменений и бюджет паблишера
				// сервер отправляет только паблишер-админам и супер-админам
				if (eventName === 'show') {

					Server.sendToServer({
						GetCreativeAI: {
							creativeId: this.creative.id
						}
					});

				}

				let aiUsers = _.orderBy(_.values(Asset.getGenerationsMoneySpentByUsers(this.creative.id)), 'id');
				let partLength = Math.ceil(aiUsers.length / 3);

				this.aiUsers[0] = aiUsers.slice(0, partLength);
				this.aiUsers[1] = aiUsers.slice(partLength, partLength * 2);
				this.aiUsers[2] = aiUsers.slice(partLength * 2);

			},
			setTransferAmount(amount) {

				this.transferAmount = amount;

			},
			// Максимальная сумма перевода - больший из бюджетов паблишера и креатива (перевод возможен в обе стороны), с округлением вниз до центов
			limitTransferAmount(amount) {

				let maxAmount = Math.max(this.publisherBudget ? this.publisherBudget['ai_budget'] : 0, this.budget ? this.budget['ai_budget'] : 0, 0);

				return Math.min(amount, Math.floor(maxAmount * 100) / 100);

			},
			transferToCreative() {

				Server.sendToServer({
					TransferPublisherAIBudgetToCreative: {
						creativeId: this.creative.id,
						amount: this.transferAmount
					}
				});

				this.clearTransferAmount();

			},
			transferToPublisher() {

				Server.sendToServer({
					TransferCreativeAIBudgetToPublisher: {
						creativeId: this.creative.id,
						amount: this.transferAmount
					}
				});

				this.clearTransferAmount();

			},
			// После перевода бюджета очищаем поле суммы
			clearTransferAmount() {

				this.transferAmount = 0;
				this.transferInputKey++;

			},
			setBudgetAmount(amount) {

				this.amount = amount;

			},
			canChangeBudget() {

				return this.amount > 0 && this.reason.trim().length > 0;

			},
			addBudget() {

				Server.sendToServer({
					AddCreativeAIBudget: {
						creativeId: this.creative.id,
						amount: this.amount,
						reason: this.reason.trim()
					}
				});

				this.clearBudgetChange();

			},
			removeBudget() {

				Server.sendToServer({
					RemoveCreativeAIBudget: {
						creativeId: this.creative.id,
						amount: this.amount,
						reason: this.reason.trim()
					}
				});

				this.clearBudgetChange();

			},
			// После добавления / отнимания бюджета очищаем сумму и причину
			clearBudgetChange() {

				this.amount = 0;
				this.reason = '';
				this.budgetInputKey++;

			},
			formatDate(date) {

				return new Date(date).toLocaleString();

			},
			saveOption(optionName, newData) {

				this.creative.options[optionName] = newData;

				Server.sendWithTimeout({
					UpdateCreativeOptions: {
						creativeId: this.creative.id,
						[optionName]: this.creative.options[optionName]
					}
				}, null, 300);

			}
		}
	}
</script>


<style lang="sass">

	.creative-ai-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.project-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 750px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

		.form-line
			display: flex
			flex-direction: row

		.form-group
			display: flex
			flex-direction: column

		.multi-select-checkbox
			margin-bottom: 10px
			margin-right: 20px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.form-group

			> .description
				margin-bottom: 10px

			.budget-line
				margin-top: 5px

		.form-line
			align-items: center

		.form-line.budget
			margin-bottom: 10px

			.input-select-control
				margin-right: 20px

				input
					width: 80px

			.reason
				width: 300px

			.btn-primary
				margin-right: 20px

		.form-line.budget-buttons

			.btn-primary
				margin-right: 20px

		.btn

			.fa
				margin-right: 7px

		.form-group.creative-ai-cost
			flex-direction: column
			flex-wrap: nowrap
			padding-bottom: 1rem
			user-select: none

			> .description
				margin-bottom: 20px

			.columns-3
				display: flex
				flex-direction: row
				justify-content: space-between

				.column
					display: flex
					flex-direction: column

		.budget-log-records
			position: relative
			overflow: hidden

			.budget-log-record
				display: flex
				flex-direction: row
				align-items: center
				white-space: nowrap

				.date
					width: 170px

				.amount
					width: 90px
					color: #4dbd74

					&.negative
						color: var(--red)

				.user
					width: 150px
					overflow: hidden
					text-overflow: ellipsis

				.reason
					flex: 1
					overflow: hidden
					text-overflow: ellipsis
					margin-right: 10px

		.form-actions
			margin-top: 20px

	.creative-ai-settings.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>

